/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1054
 */

module.exports = {
  container: "StageRuler_container__2NbYZ",
  hRuler: "StageRuler_hRuler__3uPSv",
  vRuler: "StageRuler_vRuler__1soP0"
}
